import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { useParams, Link } from 'react-router-dom';
import dummyImg from '../assets/images/shared image.jfif'
import './Listing.css'; // Fixed import
import "@fontsource/inter/400.css";
import { Container, Row, Col, Form, Card, Button, } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import bannerImage from '../assets/images/banner.png';
import residentialPlot from '../assets/images/residential-plots.jpg';
import { FaArrowRight } from 'react-icons/fa';
import img1 from '../assets/images/img (1).png';
import img2 from '../assets/images/img (2).png';
import img4 from '../assets/images/img (4).png';
import img5 from '../assets/images/img (5).png';

const Listing = () => {
  const hyderabadCoords = [17.385044, 78.486671];
  const navigate = useNavigate();
  const [filter, setFilter] = useState("*");

  // Sample property data
  const [properties, setProperties] = useState([
    {
      id: 1,
      title: "Shashank's Plot",
      price: 1960.00,
      location: "Hyderabad, Telangana",
      image: bannerImage
    },
    {
      id: 2,
      title: "Shiva's Plot",
      price: 1880.00,
      location: "Hyderabad, Telangana",
      image: residentialPlot
    },
    {
      id: 3,
      title: "Premium Plot",
      price: 2500.00,
      location: "Hyderabad, Telangana",
      image: bannerImage
    },
    {
      id: 4,
      title: "Budget Plot",
      price: 1200.00,
      location: "Hyderabad, Telangana",
      image: residentialPlot
    },
    {
      id: 5,
      title: "Luxury Plot",
      price: 3500.00,
      location: "Hyderabad, Telangana",
      image: bannerImage
    },
    {
      id: 6,
      title: "Economy Plot",
      price: 950.00,
      location: "Hyderabad, Telangana",
      image: residentialPlot
    }
  ]);

  const [filteredProperties, setFilteredProperties] = useState(properties);
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');

  // Calculate min and max values from properties for the range inputs
  const prices = properties.map(property => property.price);
  const absoluteMin = Math.min(...prices);
  const absoluteMax = Math.max(...prices);

  // Apply filters when minPrice or maxPrice changes
  useEffect(() => {
    let filtered = properties;

    if (minPrice !== '') {
      filtered = filtered.filter(property => property.price >= parseFloat(minPrice));
    }

    if (maxPrice !== '') {
      filtered = filtered.filter(property => property.price <= parseFloat(maxPrice));
    }

    setFilteredProperties(filtered);
  }, [minPrice, maxPrice, properties]);

  const handleMinPriceChange = (e) => {
    const value = e.target.value;
    setMinPrice(value === '' ? '' : parseFloat(value));
  };

  const handleMaxPriceChange = (e) => {
    const value = e.target.value;
    setMaxPrice(value === '' ? '' : parseFloat(value));
  };

  const handleResetFilters = () => {
    setMinPrice('');
    setMaxPrice('');
  };

  // Data arrays for plots website
const plotTypes = [
  {
    type: "Residential Plots",
    image: "../assets/images/residential-plots.jpg",
    icon: "/assets/images/residential-icon.svg",
    colorClass: "plotBlue",
    features: [
      "Prime residential areas",
      "Clear titles & approvals",
      "Ready for construction",
      "Excellent amenities nearby",
      "Flexible payment plans",
      "High appreciation potential"
    ]
  },
  // Add other plot types similarly
];

const developmentImages = [
  residentialPlot,
  // residentialPlot,
  // residentialPlot,
  // residentialPlot,
];

const propertyListings = [
  {
    title: "Green Valley Residential Plots",
    image: img2,
    link: "/property/green-valley",
    size: "500-1000 sq.yd",
    location: "North City",
    category: "residential"
  },
  {
    title: "Sunshine Apartments",
    image: img4,
    link: "/property/sunshine-apartments",
    size: "1200 sq.ft",
    location: "East Town",
    category: "residential"
  },
  {
    title: "Hill View Villas",
    image: img5,
    link: "/property/hill-view-villas",
    size: "2000 sq.ft",
    location: "South Hill",
    category: "residential"
  },
  {
    title: "City Center Office Space",
    image: img1,
    link: "/property/city-center-office",
    size: "1500 sq.ft",
    location: "Downtown",
    category: "commercial"
  },
  {
    title: "Industrial Warehouse",
    image: img2,
    link: "/property/industrial-warehouse",
    size: "5000 sq.ft",
    location: "Industrial Zone",
    category: "commercial"
  },
  {
    title: "Retail Complex",
    image: img4,
    link: "/property/retail-complex",
    size: "2500 sq.ft",
    location: "Main Market",
    category: "commercial"
  }
];

  return (
     <>
      <div className="mainProperties propertyBg pt-60" id="properties">
        <div className="dashboard-map-frame">
          <MapContainer
            center={hyderabadCoords}
            zoom={9}
            style={{ height: "75vh", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <Marker position={hyderabadCoords}>
              <Popup>Hyderabad, Telangana, India</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>

      {/* Price Filter Section */}
      <Container className="mt-4">
        <Row className="mb-4">
          <Col sm={5}>
            <Card className="filter-card p-3">
              <h5 className="mb-1">Filter by Price</h5><hr />
              <Row>
                <Col md={4} className="mb-2">
                  <Form.Group>
                    <Form.Label>Min Price (₹)</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Min price"
                      value={minPrice}
                      onChange={handleMinPriceChange}
                      min={absoluteMin}
                      max={absoluteMax}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="mb-2">
                  <Form.Group>
                    <Form.Label>Max Price (₹)</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Max price"
                      value={maxPrice}
                      onChange={handleMaxPriceChange}
                      min={absoluteMin}
                      max={absoluteMax}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="d-flex align-items-end mb-2">
                  <Button
                    variant="outline-secondary"
                    onClick={handleResetFilters}
                    className="w-100 resetBtn"
                  >
                    Reset Filters
                  </Button>
                </Col>
              </Row>
              <div className="mt-3">
                <Form.Label>
                  Price Range: ₹{minPrice || absoluteMin} - ₹{maxPrice || absoluteMax}
                </Form.Label>
                <Form.Range
                  min={absoluteMin}
                  max={absoluteMax}
                  value={minPrice || absoluteMin}
                  onChange={(e) => setMinPrice(parseFloat(e.target.value))}
                  className="mb-2"
                />
                <Form.Range
                  min={absoluteMin}
                  max={absoluteMax}
                  value={maxPrice || absoluteMax}
                  onChange={(e) => setMaxPrice(parseFloat(e.target.value))}
                />
              </div>
            </Card>
          </Col>
        </Row>

        {/* Results count */}
        <Row className="mb-3">
          <Col sm={5}>
            <p className="propertyFound">
              {filteredProperties.length} Property{filteredProperties.length !== 1 ? 'ies' : ''} Found
            </p>
          </Col>
        </Row>

        {/* Property Cards */}
        <Row>
          {filteredProperties.length > 0 ? (
            filteredProperties.map(property => (
              <Col key={property.id} sm={6} md={4} className="mb-4">
                <Card className='mainCard h-100'>
                  <Card.Img variant="top" className='imgCard' src={property.image} />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title style={{ fontWeight: 600 }}>{property.title}</Card.Title>
                    <div className="mt-auto">
                      <Row>
                        <Col sm={7}>
                          <div className="card-text-content">
                            <div className='m-0'>₹{property.price.toFixed(2)}</div>
                            <div>{property.location}</div>
                          </div>
                        </Col>
                        <Col sm={5}>
                          <Link to="/GetDetailsByName" className="details-button">
                            Details <FaArrowRight className="arrow-icon" />
                          </Link>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <div className="text-center py-5">
                <h4>No properties found matching your criteria</h4>
                <p>Try adjusting your price filters</p>
                <Button variant="primary" onClick={handleResetFilters}>
                  Reset Filters
                </Button>
              </div>
            </Col>
          )}
        </Row>
        
      </Container>
      
      {/* Featured Properties */}
      <section className="featuredProperties pt-120 pb-70" id="listings">
        <Container>
          <Row className="mb-40">
            <Col xs={12}>
              <div className="sectionIntro text-center">
                <h5 className="dark">CURRENT LISTINGS</h5>
                <h2 className="sectionTitle dark lightTitle">Featured Plots Available Now</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="text-center">
                <div className="propertyFilter mb-40">
                  <button className={filter === "*" ? "active" : ""} onClick={() => setFilter("*")}>All Plots</button>
                  <button className={filter === "residential" ? "active" : ""} onClick={() => setFilter("residential")}>Residential</button>
                  <button className={filter === "commercial" ? "active" : ""} onClick={() => setFilter("commercial")}>Commercial</button>
                </div>

              </div>
            </Col>
          </Row>
          <Row id="propertyGrid" className="propertyGrid">
            {propertyListings
              .filter(property => filter === "*" || property.category === filter)
              .map((property, index) => (
                <Col lg={4} md={6} key={index} className={`gridItem ${property.category}`}>
                  <div className="propertyCard mb-30">
                    <div className="propertyImage">
                      <a href={property.link}>
                        <img src={property.image} alt={property.title} />
                      </a>
                    </div>
                    <div className="propertyDetails">
                      <h3 className="propertyTitle">
                        <a style={{ color: 'black', textDecoration: 'none' }} href={property.link}>{property.title}</a>
                      </h3>
                      <h4 style={{ fontSize: '18px' }}>{property.size} • {property.location}</h4>
                      <div className="viewDetails">
                        <a href={property.link}>
                          View Details <span>→</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}

          </Row>
        </Container>
      </section> 
    </>
  );
}

export default Listing;